import { MLSListing, toPunctuatedPhoneFormat } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn.js';
import MLSDataInfoSection from './MLSDataInfoSection.js';
import MlsDataValueWithLabel from './MLSDataValueWithLabel.js';

const MLSAgentDetails = ({ listingData }: { listingData: MLSListing }) => (
  <>
    <MLSDataInfoSection title="Agent Details">
      <MLSDataColumn>
        <MlsDataValueWithLabel value={listingData.ListAgentFullName} label="Listing Agent" />
        <MlsDataValueWithLabel
          value={
            listingData.ListAgentPreferredPhone
              ? toPunctuatedPhoneFormat(listingData.ListAgentPreferredPhone)
              : ''
          }
          label="Phone"
        />
        <MlsDataValueWithLabel
          value={listingData.ListAgentMlsID ?? listingData.ListAgentKey}
          label="Agent ID"
        />
      </MLSDataColumn>
      <MLSDataColumn>
        <MlsDataValueWithLabel value={listingData.ListOfficeName} label="Listing Office" />
        <MlsDataValueWithLabel
          value={
            listingData.ListOfficePhone ? toPunctuatedPhoneFormat(listingData.ListOfficePhone) : ''
          }
          label="Phone"
        />
        <MlsDataValueWithLabel
          value={listingData.ListOfficeMlsId ?? listingData.ListOfficeKey}
          label="Office ID"
        />
      </MLSDataColumn>
    </MLSDataInfoSection>
    {/* <MlsDataValueWithLabel value={listingData.agents?.listing_agent?.remarks} label="Listing Agent Remarks" /> */}
  </>
);

export default MLSAgentDetails;
